import { useState, useCallback } from 'react';
import debounce from 'react-utils/debounce';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UISelect from 'UIComponents/input/UISelect';
import Small from 'UIComponents/elements/Small';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import { useQuery } from 'data-fetching-client';
import { SEARCH_ILS_LIST_BY_TYPE } from 'automation-ui-enrollment/queries/ILSListQueries';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const makeOptions = results => {
  return results.map(obj => {
    // hs_list_name and hs_list_id are always fetched from SEARCH_ILS_LIST_BY_TYPE
    const text = obj.properties.hs_list_name.value;
    const value = Number(obj.properties.hs_list_id.value);
    return {
      text,
      value
    };
  });
};
const SEARCH_DEBOUNCE_MS = 250;
const ListSelect = ({
  objectTypeId,
  selectedListId,
  onListSelect
}) => {
  const [query, setQuery] = useState('');

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSetQuery = useCallback(debounce(setQuery, SEARCH_DEBOUNCE_MS), []);
  const {
    loading,
    error,
    data
  } = useQuery(SEARCH_ILS_LIST_BY_TYPE, {
    variables: {
      objectTypeId,
      query
    }
  });
  const onChange = ({
    target: {
      value
    }
  }) => {
    const selected = Number(value);
    onListSelect(syntheticEvent(selected));
  };
  return /*#__PURE__*/_jsx(UIFormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
      baseLangKey: "automation-ui-enrollment.redesign.enrollExistingPanel.enrollFromList.selected.listType_cob",
      objectTypeId: objectTypeId
    }),
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(UISelect, {
        disabled: !!error,
        onChange: onChange,
        onInputValueChange: ({
          target: {
            value
          }
        }) => debouncedSetQuery(value),
        placeholder: I18n.text('automation-ui-enrollment.generic-enrollment-table.select-list-placeholder'),
        isLoading: loading || !data,
        value: selectedListId,
        options: data && data.searchIlsListByType && data.searchIlsListByType.results && makeOptions(data.searchIlsListByType.results)
      }), error && /*#__PURE__*/_jsx(Small, {
        use: "error",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.redesign.enrollExistingPanel.enrollFromList.listsError"
        })
      })]
    })
  });
};
export default ListSelect;